<template>
    <v-app>
        <v-card width="400" class="mx-auto mt-5" v-show="page == 'first'">
            <v-card-title>FaberX Emergency Broadcast</v-card-title>
            <v-card-text>
                <v-form>
                    <v-text-field v-model="phoneno" type="tel"  label="*Phone No (i.e. +65 555...)"/>
                    <v-text-field v-model="name" label="*Name"/>
                </v-form>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-btn color="success" :disabled="!subscribeValid()" v-on:click="subscribe(phoneno)">Subscribe</v-btn>
                <v-spacer></v-spacer>
                <v-btn color="info" :disabled="!unsubscribeValid()" v-on:click="unsubscribe">Un-Subscribe</v-btn>
            </v-card-actions>
        </v-card>

        <v-card width="400" class="mx-auto mt-5" v-show="page=='confirm'">
            <v-card-title>Activate WhatsApp</v-card-title>
            <v-card-text>
                <div class="body-1">
                    You need to authorize WhatApp by texting "join tone-dream" to +1 415 523 8886, which can be done
                    with this
                    <a href="whatsapp://send?phone=%2B14155238886&text=join+tone-dream">link</a>.
                    <br><br>
                    Once done, press Finish below and you'll be added to the FaberX Emergency Broadcast.
                </div>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-btn color="success" v-on:click="finish(phoneno)">Finish</v-btn>
                <v-spacer></v-spacer>
                <v-btn color="info" v-on:click="page='first'">Cancel</v-btn>
            </v-card-actions>
        </v-card>

        <v-card width="400" class="mx-auto mt-5" v-show="page=='done'">
            <v-card-title>Congratulations!!!</v-card-title>
            <v-card-text>
                <div class="body-1">
                    You have now subscribed to the FaberX Emergency Broadcast.
                    <br><br>
                    Please point your emergency contact number to ‭+12566335737.
                    All SMS's sent to this number will be sent to all subscribers.
                </div>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-btn color="success" v-on:click="page='first'">Done</v-btn>
            </v-card-actions>
        </v-card>


    </v-app>
</template>

<script>
    // import HelloWorld from './components/HelloWorld';
    import { subscriptionsCollection } from "./fb";

    export default {
        name: 'App',

        components: {
            // HelloWorld,
        },

        methods: {
            subscribeValid: function() {
                return this.phoneno.match(/^\+[ \-0-9]+$/) && this.name.length > 1
            },
            unsubscribeValid: function() {
                return this.phoneno.match(/^\+[ \-0-9]+$/)
            },
            subscribe: async function () {
                this.phoneno = this.phoneno.replace(/\s/g, '')
                this.page = 'confirm'
                await subscriptionsCollection.doc(this.phoneno).set({
                    'name': this.name,
                    'created': new Date()
                })
            },
            finish: async function () {
                this.phoneno = ""
                this.name = ""
                this.page = 'done'
            },
            unsubscribe: async function () {
                this.phoneno = this.phoneno.replace(/\s/g, '')
                await subscriptionsCollection.doc(this.phoneno).delete()
                this.phoneno = ""
                this.name = ""
            }
        },

        data: () => ({
            valid: true,
            phoneno: "",
            page: "first",
            name: "",
        }),
    };
</script>
